(function () {
  const SELECTORS = {
    root: '#ContractBuilder',
    config: '[id^="ContractBuilderConfig-"]',
    variants: '[id^="ContractBuilderVariants-"]',
    flowCard: '[data-flow]',
    flowPanel: '[data-flow-panel]',
    field: '[data-field]',
    contractTermWrapper: '[data-contract-term-wrapper]',
    planSection: '[data-plan-section]',
    planTable: '[data-plan-table]',
    extrasWrapper: '[data-extras-wrapper]',
    extrasList: '[data-extras-list]',
    priceMonthly: '[data-price-monthly]',
    priceExtras: '[data-price-extras]',
    priceOnceOff: '[data-price-once-off]',
    error: '[data-cb-error]',
    productForm: '[data-product-form]',
    storageSelect: '[data-storage-select]',
    colourSelect: '[data-colour-select]'
  };

  const CONTRACT_FLOWS = ['upgrade', 'port', 'new_contract'];

  const state = {
    flow: null,
    selectedStorage: '',
    selectedColour: '',
    selectedVariantId: '',
    applicationType: '',
    upgradeType: '',
    mtnNumber: '',
    portNumber: '',
    contractTerm: '',
    selectedPlanCode: '',
    selectedPlanName: '',
    selectedPlanPricePm: 0,
    extras: [],
    extrasTotalOnceOff: 0,
    onceOffTotal: 0,
    monthlyTotal: 0
  };

  let root;
  let config;
  let variants = [];

  document.addEventListener('DOMContentLoaded', initContractBuilder);

  function initContractBuilder() {
    root = document.querySelector(SELECTORS.root);
    if (!root) return;

    config = getConfig() || {};
    variants = getVariants();

    bindEvents();
    initDeviceOptions();
    renderExtras();
    calculatePricing();
    syncHiddenFields();

    if (!variants.length) {
      showError('No product variants found. Please check the ContractBuilderVariants script in Liquid.');
    }

    if (!config.plans_by_storage) {
      console.warn('Contract plans are missing or not using plans_by_storage structure.');
    }
  }

  function getConfig() {
    const node = root.querySelector(SELECTORS.config);
    if (!node) return null;

    try {
      let parsed = JSON.parse(node.textContent || '{}');

      if (typeof parsed === 'string') {
        parsed = JSON.parse(parsed);
      }

      return parsed;
    } catch (error) {
      console.error('Invalid contract builder JSON:', error);
      return null;
    }
  }

  function getVariants() {
    const node = root.querySelector(SELECTORS.variants);
    if (!node) return [];

    try {
      let parsed = JSON.parse(node.textContent || '[]');

      if (typeof parsed === 'string') {
        parsed = JSON.parse(parsed);
      }

      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.error('Invalid variant JSON:', error);
      return [];
    }
  }

  function bindEvents() {
    root.querySelectorAll(SELECTORS.flowCard).forEach((button) => {
      button.addEventListener('click', () => selectFlow(button.dataset.flow));
    });

    root.addEventListener('change', (event) => {
      const field = event.target.closest(SELECTORS.field);
      if (field) handleFieldChange(field.dataset.field, field.value);

      const extraInput = event.target.closest('[data-extra-code]');
      if (extraInput) handleExtraChange(extraInput.dataset.extraCode, extraInput.checked);
    });

    root.addEventListener('input', (event) => {
      const field = event.target.closest(SELECTORS.field);
      if (!field) return;
      handleFieldChange(field.dataset.field, field.value);
    });

    root.addEventListener('click', (event) => {
      const planButton = event.target.closest('[data-plan-code]');
      if (planButton) selectPlan(planButton.dataset.planCode);
    });

    const form = root.querySelector(SELECTORS.productForm);
    if (form) {
      form.addEventListener('submit', (event) => {
        hideError();
        syncHiddenFields();

        const validation = validateBeforeSubmit();

        if (!validation.valid) {
          event.preventDefault();
          showError(validation.message);
        }
      });
    }
  }

  function initDeviceOptions() {
    const storageSelect = root.querySelector(SELECTORS.storageSelect);
    const colourSelect = root.querySelector(SELECTORS.colourSelect);

    if (!variants.length || !storageSelect || !colourSelect) return;

    const storages = [...new Set(variants.map((v) => v.option2).filter(Boolean))];
    const colours = [...new Set(variants.map((v) => v.option1).filter(Boolean))];

    storages.forEach((storage) => {
      storageSelect.insertAdjacentHTML(
        'beforeend',
        `<option value="${escapeHtml(storage)}">${escapeHtml(storage)}</option>`
      );
    });

    colours.forEach((colour) => {
      colourSelect.insertAdjacentHTML(
        'beforeend',
        `<option value="${escapeHtml(colour)}">${escapeHtml(colour)}</option>`
      );
    });
  }

  function handleFieldChange(fieldName, value) {
    switch (fieldName) {
      case 'selected_storage':
        state.selectedStorage = value;
        resetPlanSelection();
        updateSelectedVariant();
        readVisibleFlowFields();
        renderPlansForCurrentState();
        break;

      case 'selected_colour':
        state.selectedColour = value;
        updateSelectedVariant();
        break;

      case 'application_type':
        state.applicationType = value;
        resetPlanSelection();
        renderPlansForCurrentState();
        break;

      case 'upgrade_type':
        state.upgradeType = value;
        break;

      case 'mtn_number':
        state.mtnNumber = value;
        break;

      case 'port_number':
        state.portNumber = value;
        break;

      case 'contract_term':
        state.contractTerm = value;
        resetPlanSelection();
        readVisibleFlowFields();
        renderPlansForCurrentState();
        toggleContractUI();
        break;

      default:
        break;
    }

    calculatePricing();
    syncHiddenFields();
  }

  function updateSelectedVariant() {
    if (!state.selectedStorage || !state.selectedColour) return;

    const selectedVariant = variants.find((variant) => {
      return (
        normaliseKey(variant.option2) === normaliseKey(state.selectedStorage) &&
        normaliseKey(variant.option1) === normaliseKey(state.selectedColour)
      );
    });

    if (!selectedVariant) {
      state.selectedVariantId = '';
      showError('This storage and colour combination is not available.');
      return;
    }

    state.selectedVariantId = selectedVariant.id;
    hideError();

    const variantInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');

    if (variantInput) {
      variantInput.value = selectedVariant.id;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function selectFlow(flow) {
    hideError();

    if (!state.selectedStorage || !state.selectedColour) {
      showError('Please select your storage and colour first.');
      return;
    }

    setActiveFlowCard(flow);

    if (flow === 'pay_now') {
      setTimeout(() => {
        addPayNowToCart();
      }, 300);
      return;
    }

    root.classList.add('cb-contract-active');
    document.body.classList.add('cb-contract-active');

    state.flow = flow;

    resetContractState();
    showFlowPanel(flow);
    readVisibleFlowFields();
    renderPlansForCurrentState();
    toggleContractUI();
    calculatePricing();
    syncHiddenFields();
  }

  function readVisibleFlowFields() {
    if (!state.flow) return;

    const activePanel = root.querySelector(`[data-flow-panel="${state.flow}"]`);
    if (!activePanel) return;

    const applicationType = activePanel.querySelector('[data-field="application_type"]');
    const upgradeType = activePanel.querySelector('[data-field="upgrade_type"]');
    const mtnNumber = activePanel.querySelector('[data-field="mtn_number"]');
    const portNumber = activePanel.querySelector('[data-field="port_number"]');

    if (applicationType) state.applicationType = applicationType.value || '';
    if (upgradeType) state.upgradeType = upgradeType.value || '';
    if (mtnNumber) state.mtnNumber = mtnNumber.value || '';
    if (portNumber) state.portNumber = portNumber.value || '';
  }

  function addPayNowToCart() {
    const variantId = state.selectedVariantId || getCurrentVariantId();

    if (!variantId) {
      showError('Please select an available storage and colour combination.');
      return;
    }

    window.location.href = '/cart/add?id=' + variantId + '&quantity=1';
  }

  function getCurrentVariantId() {
    const variantInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return variantInput ? variantInput.value : '';
  }

  function resetContractState() {
    state.contractTerm = '';
    state.applicationType = '';
    state.upgradeType = '';
    state.mtnNumber = '';
    state.portNumber = '';

    resetPlanSelection();

    const termSelect = root.querySelector('[data-field="contract_term"]');
    if (termSelect) termSelect.value = '';

    const applicationTypeSelects = root.querySelectorAll('[data-field="application_type"]');
    applicationTypeSelects.forEach((select) => {
      select.value = '';
    });

    const upgradeTypeSelect = root.querySelector('[data-field="upgrade_type"]');
    if (upgradeTypeSelect) upgradeTypeSelect.value = '';

    const mtnNumberInput = root.querySelector('[data-field="mtn_number"]');
    if (mtnNumberInput) mtnNumberInput.value = '';

    const portNumberInput = root.querySelector('[data-field="port_number"]');
    if (portNumberInput) portNumberInput.value = '';

    renderPlans('');
  }

  function resetPlanSelection() {
    state.selectedPlanCode = '';
    state.selectedPlanName = '';
    state.selectedPlanPricePm = 0;

    root.querySelectorAll('[data-plan-code]').forEach((button) => {
      button.classList.remove('is-active');
      button.setAttribute('aria-pressed', 'false');
    });
  }

  function setActiveFlowCard(flow) {
    root.querySelectorAll(SELECTORS.flowCard).forEach((button) => {
      const isActive = button.dataset.flow === flow;

      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function showFlowPanel(flow) {
    root.querySelectorAll(SELECTORS.flowPanel).forEach((panel) => {
      panel.hidden = panel.dataset.flowPanel !== flow;
    });
  }

  function toggleContractUI() {
    const isContractFlow = CONTRACT_FLOWS.includes(state.flow);

    const termWrapper = root.querySelector(SELECTORS.contractTermWrapper);
    const planSection = root.querySelector(SELECTORS.planSection);
    const extrasWrapper = root.querySelector(SELECTORS.extrasWrapper);
    const pricingSummary = root.querySelector('[data-pricing-summary]');

    if (termWrapper) termWrapper.hidden = !isContractFlow;

    if (planSection) {
      planSection.hidden = !(
        isContractFlow &&
        state.selectedStorage &&
        state.applicationType &&
        state.contractTerm
      );
    }

    if (extrasWrapper) extrasWrapper.hidden = true;
    if (pricingSummary) pricingSummary.hidden = !isContractFlow;
  }

  function renderPlansForCurrentState() {
    readVisibleFlowFields();

    if (!state.selectedStorage || !state.applicationType || !state.contractTerm) {
      renderPlans('');
      toggleContractUI();
      return;
    }

    renderPlans(state.contractTerm);
    toggleContractUI();
  }

  function getPlansForCurrentSelection(term) {
    if (!config || !config.plans_by_storage) return [];

    const cleanStorage = normaliseKey(state.selectedStorage);
    const cleanTerm = String(term || '').trim();
    const cleanApp = normaliseApplicationType(state.applicationType);

    const storageKey = Object.keys(config.plans_by_storage).find((key) => {
      return normaliseKey(key) === cleanStorage;
    });

    if (!storageKey) return [];

    const storagePlans = config.plans_by_storage[storageKey] || {};

    const appKey = Object.keys(storagePlans).find((key) => {
      return normaliseApplicationType(key) === cleanApp;
    });

    if (!appKey) return [];

    const appPlans = storagePlans[appKey] || {};

    const termKey = Object.keys(appPlans).find((key) => {
      return String(key || '').trim() === cleanTerm;
    });

    if (!termKey) return [];

    const plans = appPlans[termKey];

    if (!Array.isArray(plans)) return [];

    return plans.filter((plan) => {
      return plan.plan_name && Number(getPlanMonthlyTotal(plan) || 0) > 0;
    });
  }

  function normaliseApplicationType(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '_');
  }

  function normaliseKey(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '');
  }

  function renderPlans(term) {
    const planTable = root.querySelector(SELECTORS.planTable);
    if (!planTable) return;

    planTable.innerHTML = '';

    if (!term) return;

    const plans = getPlansForCurrentSelection(term);

    if (!plans.length) {
      planTable.innerHTML = '<p>No plans are currently available for this selection.</p>';
      return;
    }

    plans.forEach((plan) => {
      const button = document.createElement('button');

      button.type = 'button';
      button.className = 'cb-plan-card';
      button.dataset.planCode = plan.plan_code;

      button.innerHTML = `
        <span>
          <span class="cb-plan-name">${escapeHtml(plan.plan_name)}</span>
          <span class="cb-plan-benefits">${escapeHtml(plan.benefits || '')}</span>
        </span>
        <span class="cb-plan-price">${formatMoney(getPlanMonthlyTotal(plan))} /pm</span>
      `;

      planTable.appendChild(button);
    });
  }

  function selectPlan(planCode) {
    const plans = getPlansForCurrentSelection(state.contractTerm);
    const selectedPlan = plans.find((plan) => plan.plan_code === planCode);

    if (!selectedPlan) return;

    state.selectedPlanCode = selectedPlan.plan_code;
    state.selectedPlanName = selectedPlan.plan_name;
    state.selectedPlanPricePm = getPlanMonthlyTotal(selectedPlan);

    root.querySelectorAll('[data-plan-code]').forEach((button) => {
      const isActive = button.dataset.planCode === planCode;

      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    calculatePricing();
    syncHiddenFields();
  }

  function getPlanMonthlyTotal(plan) {
    let value = 0;

    if (plan.total_price_pm) {
      if (typeof plan.total_price_pm === 'number') {
        value = plan.total_price_pm;
      }

      if (typeof plan.total_price_pm === 'string') {
        value = Number(plan.total_price_pm);
      }

      if (
        typeof plan.total_price_pm === 'object' &&
        plan.total_price_pm.amount
      ) {
        value = Number(plan.total_price_pm.amount);
      }
    }

    if (!value) {
      const planPrice = Number(plan.plan_price_pm || 0);
      const subsidy = Number(plan.device_subsidy_pm || 0);

      value = planPrice + subsidy;
    }

    if (value >= 10000) {
      value = value / 100;
    }

    return value;
  }

  function renderExtras() {
    const extrasList = root.querySelector(SELECTORS.extrasList);
    const wrapper = root.querySelector(SELECTORS.extrasWrapper);

    if (extrasList) {
      extrasList.innerHTML = '';
    }

    if (wrapper) {
      wrapper.hidden = true;
    }
  }

  function handleExtraChange(extraCode, checked) {
    state.extras = [];
    state.extrasTotalOnceOff = 0;
    state.onceOffTotal = 0;

    calculatePricing();
    syncHiddenFields();
  }

  function calculatePricing() {
    state.extrasTotalOnceOff = 0;

    if (CONTRACT_FLOWS.includes(state.flow)) {
      state.monthlyTotal = Number(state.selectedPlanPricePm || 0);
      state.onceOffTotal = 0;
    } else {
      state.monthlyTotal = 0;
      state.onceOffTotal = 0;
    }

    updatePricingUI();
  }

  function updatePricingUI() {
    const monthlyNode = root.querySelector(SELECTORS.priceMonthly);
    const extrasNode = root.querySelector(SELECTORS.priceExtras);
    const onceOffNode = root.querySelector(SELECTORS.priceOnceOff);

    if (monthlyNode) {
      monthlyNode.textContent = `${formatMoney(state.monthlyTotal)} /pm`;
    }

    if (extrasNode) {
      const extrasRow = extrasNode.closest('.cb-price-row');
      if (extrasRow) extrasRow.hidden = true;
    }

    if (onceOffNode) {
      const onceOffRow = onceOffNode.closest('.cb-price-row');
      if (onceOffRow) onceOffRow.hidden = true;
    }
  }

  function syncHiddenFields() {
    setItorisValue('F1', state.applicationType || '');
    setItorisValue('F3', state.selectedStorage || '');
    setItorisValue('F4', state.selectedColour || '');
    setItorisValue('F5', state.contractTerm || '');
    setItorisValue('F13', state.selectedPlanCode || '');
    setItorisValue('F14', state.selectedPlanName || '');
    setItorisValue('F15', state.monthlyTotal || 0);

    window.contractBuilderSnapshot = {
      flow: state.flow || '',
      storage: state.selectedStorage || '',
      colour: state.selectedColour || '',
      variant_id: state.selectedVariantId || '',
      application_type: state.applicationType || '',
      upgrade_type: state.upgradeType || '',
      mtn_number: state.mtnNumber || '',
      port_number: state.portNumber || '',
      contract_term: state.contractTerm || '',
      plan_code: state.selectedPlanCode || '',
      plan_name: state.selectedPlanName || '',
      monthly_price: state.monthlyTotal || 0,
      extras_selected: '',
      extras_total: 0,
      once_off_total: 0
    };
  }

  function setItorisValue(fieldId, value) {
    const field = document.getElementById(fieldId);
    if (!field) return;

    field.value = value == null ? '' : String(value);
    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function validateBeforeSubmit() {
    if (!state.selectedStorage || !state.selectedColour) {
      return { valid: false, message: 'Please select your storage and colour.' };
    }

    if (!state.flow) {
      return { valid: false, message: 'Please select how you would like to continue.' };
    }

    if (state.flow === 'upgrade') {
      if (!state.applicationType) return { valid: false, message: 'Please select an application type.' };
      if (!state.upgradeType) return { valid: false, message: 'Please select an upgrade type.' };
      if (!state.mtnNumber) return { valid: false, message: 'Please enter your MTN number.' };
    }

    if (state.flow === 'port') {
      if (!state.applicationType) return { valid: false, message: 'Please select an application type.' };
      if (!state.portNumber) return { valid: false, message: 'Please enter the number you would like to port.' };
    }

    if (CONTRACT_FLOWS.includes(state.flow)) {
      if (!state.applicationType) return { valid: false, message: 'Please select Individual or Business.' };
      if (!state.contractTerm) return { valid: false, message: 'Please select a contract term.' };
      if (!state.selectedPlanCode) return { valid: false, message: 'Please select a contract plan.' };
    }

    return { valid: true, message: '' };
  }

  function showError(message) {
    const errorNode = root.querySelector(SELECTORS.error);
    if (!errorNode) return;

    errorNode.textContent = message;
    errorNode.hidden = false;
  }

  function hideError() {
    const errorNode = root.querySelector(SELECTORS.error);
    if (!errorNode) return;

    errorNode.textContent = '';
    errorNode.hidden = true;
  }

  function formatMoney(amount) {
    const number = Number(amount || 0);

    return new Intl.NumberFormat('en-ZA', {
      style: 'currency',
      currency: 'ZAR',
      maximumFractionDigits: 0
    }).format(number);
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
})();

document.addEventListener('DOMContentLoaded', function () {
  const carousel = document.querySelector('[data-media-carousel]');
  if (!carousel) return;

  const slides = carousel.querySelectorAll('[data-media-slide]');
  const thumbs = carousel.querySelectorAll('[data-media-thumb]');

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', function () {
      const index = Number(thumb.dataset.mediaThumb);

      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
      });

      thumbs.forEach((item, i) => {
        item.classList.toggle('is-active', i === index);
      });
    });
  });
});